import './App.css';
import './DarkMode.css';
import React, { useState, useEffect } from "react";
import Share from "./Share";
import * as index from './index.js'
import { AiOutlineSetting, AiOutlineQuestionCircle } from "react-icons/ai";
import { BsSun, BsMoon } from "react-icons/bs";
import { Modal } from "./Modal";

function NavBar(props) {
  const [showModal, setShowModal] = useState(false);

  return (
    <nav className="top-navigation">
      <a className="site-name" href="#">
        Headline<span className="brand-or"> or </span>Headlie
      </a>
      <div className="button-container">
        <button className="nav-button" onClick={props.theme} aria-label="Toggle theme">
          {props.currentTheme === "light" ? <BsMoon className="button-icon" /> : <BsSun className="button-icon" />}
        </button>
        <button className="nav-button" onClick={() => setShowModal("help")} aria-label="Help">
          <AiOutlineQuestionCircle className="button-icon" />
        </button>
        <button className="nav-button" onClick={() => setShowModal("settings")} aria-label="Settings">
          <AiOutlineSetting className="button-icon" />
        </button>
      </div>
      {showModal ? <Modal setShowModal={setShowModal} modalTopic={showModal} theme={props.theme} currentTheme={props.currentTheme} /> : null}
    </nav>
  );
}

function HeadlineBox(props) {
  const total = 5;
  const current = props.questionNum;

  return (
    <div className="headline-box">
      <div className="progress-bar">
        <span className="progress-label">Headline {current + 1} of {total}</span>
        <div className="progress-dots">
          {[...Array(total)].map((_, i) => (
            <span
              key={i}
              className={`dot${i < current ? ' dot-filled' : i === current ? ' dot-current' : ''}`}
            />
          ))}
        </div>
      </div>

      <div className="headline-card">
        <span className="quote-mark">&ldquo;</span>
        <p className="headline">{props.headline}</p>
      </div>

      <p className="guess-prompt">Real news or AI-generated?</p>

      <div className="options-row">
        <button className="option option-real" onClick={() => index.select("Real")}>
          <span className="option-icon">✓</span> Real
        </button>
        <button className="option option-fake" onClick={() => index.select("AI")}>
          <span className="option-icon">✗</span> Fake
        </button>
      </div>

      <button className="restart" onClick={() => index.restart()}>restart</button>
    </div>
  );
}

function getScoreMessage(correct) {
  if (correct === 5) return "Perfect score — you can't be fooled.";
  if (correct === 4) return "Almost flawless. The AI barely got you.";
  if (correct === 3) return "Solid effort. The bots are sneaky.";
  if (correct === 2) return "The algorithms had a good day today.";
  return "The bots win this round. Come back tomorrow.";
}

function ResultBox(props) {
  return (
    <div className={`result-box ${props.correct ? 'correct' : 'incorrect'}`}>
      <div className="result-badge">{props.correct ? '✓' : '✗'}</div>
      <p className="result-headline">{props.headline}</p>
      <p className="result-guess">
        You guessed: <strong>{props.guess === "AI" ? "Fake" : props.guess}</strong>
        {props.correct ? ' — Correct' : ' — Wrong'}
      </p>
      <Share
        label="Share"
        url="https://headlines.ronenjain.com"
        title={props.headline}
        text="Is this headline real or not? Play Headline or Headlie!"
        buttonID={props.buttonID}
      />
    </div>
  );
}

function Results(props) {
  const pct = Math.round((props.correct / 5) * 100);
  const barClass = props.correct >= 4 ? 'score-high' : props.correct >= 2 ? 'score-mid' : 'score-low';

  return (
    <div className="results-page">
      <div className="score-card">
        <p className="score-label">Today's Score</p>
        <p className="score-number">
          {props.correct}<span className="score-denom">/5</span>
        </p>
        <div className="score-bar-track">
          <div className={`score-bar-fill ${barClass}`} style={{ width: `${pct}%` }} />
        </div>
        <p className="score-message">{getScoreMessage(props.correct)}</p>
        <Share
          label="Share Score"
          url="https://headlines.ronenjain.com"
          title={`I scored ${props.correct}/5 on Headline or Headlie!`}
          text="Can you beat me? Play at"
          buttonID="share-score"
        />
      </div>

      <div className="results-grid">
        {props.guesses.map((object, i) => (
          <ResultBox
            key={i}
            headline={object['headline']}
            guess={object['guess']}
            correct={object['correct']}
            buttonID={i}
          />
        ))}
      </div>
    </div>
  );
}

function App(props) {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  const toggleTheme = () => {
    setTheme(t => t === 'light' ? 'dark' : 'light');
  };

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.body.className = theme;
  }, [theme]);

  return (
    <div className={`App ${theme}`}>
      <NavBar theme={toggleTheme} currentTheme={theme} />
      <header className={`App-header ${theme}`}>
        {props.game
          ? <HeadlineBox headline={props.headline} questionNum={props.questionNum} />
          : <Results correct={props.correct} incorrect={props.incorrect} guesses={props.guesses} />
        }
      </header>
    </div>
  );
}

export default App;
export { Results };
